import styled from 'styled-components'

export const AdsGrid = styled.ul`
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, 305px);
  gap: 3rem;
  justify-content: center;
`

export const AdsGridItem = styled.li`
  > div {
    height: 100%;
  }
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.firaSansTextBase}
`
